export const PADDING_OFFSET = 8;
export const TOP_BOTTOM_OFFSET = 19;
export const LEFT_RIGHT_OFFSET = 13;
